// extracted by mini-css-extract-plugin
export default {"userRow":"bz26HzDdnlZ5LskMDLH5","tablehead":"x9bIg8PoV3dImVs4SAFD"};